















































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";

import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "help/list";

  dispatchTypeDelete = "help/delete";

  deleteConfirmContent = "确认要删除该内容吗？";

  categories: any[] = [{ id: "0", name: "普通" }, { id: "1", name: "AI馆" }];

  apps: any[] = [{ id: "0", name: "羽约场馆" }, { id: "1", name: "羽约运动" }];

  columns: any[] = [
    { title: "编号", dataIndex: "id", sorter: true },
    { title: "标题", dataIndex: "title" },
    { title: "排序号", dataIndex: "sortid", sorter: true },
    { title: "查看次数", dataIndex: "hits", sorter: true },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "添加时间", dataIndex: "created_at" },
    { title: "修改时间", dataIndex: "updated_at" },
    { title: "APP", scopedSlots: { customRender: "app" } },
    { title: "类型", scopedSlots: { customRender: "category_id" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadData();
  }

  async changeStatus(val: any, id: number) {
    this.$confirm({
      title: "确认信息",
      content: "您确定要操作吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("help/status", {
          id,
          val
        });
        // console.log(res)
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadData();
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }
}
